import { customElement, noView } from 'aurelia-templating';
import { bindable } from 'aurelia-framework';

@customElement('promise-resolver')
@noView
export class PromiseResolver {
  @bindable
  resolve: (value: unknown) => void;
  resolveChanged() {
    if (this.resolve) {
      this.resolve(undefined);
    }
  }

  bind() { }

  attached() {
    this.resolveChanged();
  }
}
